import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import { Box } from '@chakra-ui/react'

const LinkedLogo = () => {
  return (
    <Box
      flex={1}
      marginTop={['-100px', '-100px', 'unset', 'unset', 'unset']}>
      <Link to="/">
        <Logo
          ml={['25px', '25px', '25px', '25px', '86px']}
          maxW={['unset', 'unset', 'unset', '100%', '100%']}
          width={['50px', '50px', '76px', '76px', '110px']}
          minW={['50px', '50px', '76px', '76px', '110px']}
        />
      </Link>
    </Box>
  )
}

export default LinkedLogo
